import { Alert, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import type { JournalScope } from './ledgerJournalApi'

interface JournalScopeBannerProps {
  scope: JournalScope
  onShowAll: () => void
  onMoneyOnly: () => void
  onClearUnit: () => void
}

/**
 * «Nima ko'rsatilyapti» — sukut TORAYISHI ochiq aytiladigan joy.
 *
 * <h2>⚠️ NEGA BU BELGI SHART</h2>
 * Sahifa sukut bo'yicha faqat PUL yozuvlarini so'raydi, jurnalda esa
 * yozuvlarning ko'pchiligi trafik (`JournalQuery` javadoc'i). Belgisiz
 * ekranda operator trafik yozuvlarini «yo'q» deb o'qirdi — jimgina
 * yolg'on, ADR-033 §5 dagi bir xil holat.
 *
 * <h2>⚠️ UCH HOLAT HAM AYTILADI, IKKITASI EMAS</h2>
 * «Hammasi» ga o'tilganda ham, birlik filtri sukutdan ustun kelganda ham
 * belgi qoladi: aks holda operator ro'yxat NEGA kengayganini bilmasdi va
 * orqaga qaytish yo'lini panel ichidan qidirardi. Har holatda amal
 * BITTA bosish.
 */
export function JournalScopeBanner({
  scope,
  onShowAll,
  onMoneyOnly,
  onClearUnit,
}: JournalScopeBannerProps) {
  const { t } = useTranslation()

  const view =
    scope.reason === 'unit'
      ? {
          message: t('ledgerJournal.scope.unitTitle', { unit: scope.unit ?? '' }),
          description: t('ledgerJournal.scope.unitBody'),
          label: t('ledgerJournal.scope.clearUnit'),
          onClick: onClearUnit,
        }
      : scope.reason === 'all'
        ? {
            message: t('ledgerJournal.scope.allTitle'),
            description: t('ledgerJournal.scope.allBody'),
            label: t('ledgerJournal.scope.showMoney'),
            onClick: onMoneyOnly,
          }
        : {
            message: t('ledgerJournal.scope.moneyTitle'),
            description: t('ledgerJournal.scope.moneyBody'),
            label: t('ledgerJournal.scope.showAll'),
            onClick: onShowAll,
          }

  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
      message={view.message}
      description={view.description}
      action={
        <Button size="small" onClick={view.onClick}>
          {view.label}
        </Button>
      }
    />
  )
}
